import { render, staticRenderFns } from "./CoinStoreDealConfirmModal.vue?vue&type=template&id=08ecf00e&scoped=true&"
import script from "./CoinStoreDealConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreDealConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreDealConfirmModal.vue?vue&type=style&index=0&id=08ecf00e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecf00e",
  null
  
)

export default component.exports